/* tslint:disable */
/* eslint-disable */

/**
 * FolderName Enum for Documents (manually registered in swagger)
 */
export enum WorkDocumentsFolderNameEnum {
  Akquise = 'Akquise',
  App = 'App',
  Artikel = 'Artikel',
  Bestellungen = 'Bestellungen',
  Chats = 'Chats',
  Projekte = 'Projekte',
  Kontakte = 'Kontakte',
  DsRechnungen = 'DS_Rechnungen',
  WpRechnungen = 'WP_Rechnungen',
  Mitarbeiter = 'Mitarbeiter',
  NichtZugewiesen = 'Nicht_Zugewiesen',
  Templates = 'Templates',
  Veranstaltungen = 'Veranstaltungen',
  Mitteilungen = 'Mitteilungen',
  Betriebsmittel = 'Betriebsmittel',
  Trixeditor = 'Trixeditor',
  Tickets = 'Tickets',
  Screen = 'Screen',
  Temp = 'temp',
  Kreditoren = 'Kreditoren',
  Spesen = 'Spesen',
  Energieversorger = 'Energieversorger',
  Optimized = '_optimized',
  Thumb = '_thumb'
}
